import { render } from "./FasciaSoffet.vue?vue&type=template&id=6e169990&scoped=true"
import script from "./FasciaSoffet.vue?vue&type=script&lang=js"
export * from "./FasciaSoffet.vue?vue&type=script&lang=js"

import "./FasciaSoffet.vue?vue&type=style&index=0&id=6e169990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e169990"]])

export default __exports__